import { postToHost } from "../lib/postmessage";
import type { LoginFormData } from "../types";
import { FormShell } from "./_form";

interface Props {
  data: LoginFormData;
  sessionToken: string;
}

export default function LoginFormCard({ data, sessionToken }: Props) {
  return (
    <FormShell
      title={data.title}
      subtitle={data.subtitle}
      fields={data.fields}
      submitLabel={data.submitLabel}
      footer={
        data.demoNote ? (
          <p className="ac-form__footer-note">{data.demoNote}</p>
        ) : undefined
      }
      onSubmit={(values) =>
        postToHost(
          "action.submit_login",
          {
            method: "password",
            email: values.email,
            password: values.password,
          },
          { sessionId: sessionToken }
        )
      }
    />
  );
}
